import React from "react";
import Marquee from "react-fast-marquee";

const phrases = [
  "Advanced Life Policies",
  "Clear skies ahead",
  "Save more, worry less",
  "Cover that feels like home",
];

export default function TrustMarquee() {
  return (
    <section
      id="marquee"
      className="relative border-y border-forest/10 bg-sand py-8 lg:py-10 overflow-hidden"
      data-testid="marquee-section"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {phrases.map((p, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif text-3xl sm:text-4xl lg:text-5xl text-forest/85 italic px-12 lg:px-16">
              {p}
            </span>
            <span className="text-terracotta text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
